import React, { useState, useEffect } from 'react';
import { getHeaderColor } from './ReportStyle.js';
import { gridLayer } from 'leaflet';

export interface ServerObject {
  details: string;
  raid_device: string;
  status: string;
}

const ServerMonitor: React.FC = () => {
  const [reportGenAt, setReportGenAt] = useState<Date | string | null>(null);
  const [serverData, setServerData] = useState<ServerObject | null>(null);
  const [show, setShow] = useState<boolean>(false);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch('/apidet/server/monitoring', {
          credentials: 'same-origin',
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();

        // Check if dataUSA contains an error
        if (data && !data.error) {
          // If the raw response is a string, parse it to JSON
          const tempreportGenAt = new Date();
          setReportGenAt(formatDate(tempreportGenAt));
          setServerData(data);
        } else {
          setServerData(null);
          setReportGenAt(null);
        }
      } catch (error) {
        setServerData(null);
        setReportGenAt(null);
        console.error('Error fetching data:', error);
      }
    };

    fetchData();

    // Fetch data every 5 seconds
    const interval = setInterval(fetchData, 5000); // temp

    // Cleanup the interval on component unmount
    return () => clearInterval(interval);
  }, []);

  const formatDate = (dateString: string | Date): string => {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is 0-based
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    return `${year}/${month}/${day} ${hours}:${minutes}:${seconds}`;
  };

  return (
    <div className="table-responsive-xl m-4">
      <table className="backend table table-hover table-dark">
        {reportGenAt !== null && serverData !== null ? (
          <>
            <thead className="table-header">
              <tr
                className="table-tr"
                style={{ fontSize: '1.2rem' }}
                onClick={() => setShow((prev) => !prev)}
              >
                <th
                  style={{ fontSize: '1.2rem' }}
                  className={getHeaderColor(reportGenAt)}
                >
                  Raid Update: {formatDate(reportGenAt)}
                </th>
                {serverData && (
                  <>
                    <th>
                      {serverData.raid_device}: {serverData.status}
                    </th>
                  </>
                )}
              </tr>
            </thead>
            {show && (
              <tbody className="expanded-table-whole">
                <tr>
                  <td colSpan={2}>{serverData.details}</td>
                </tr>
              </tbody>
            )}
          </>
        ) : (
          <th className="red">Raid Report not available</th>
        )}
      </table>
    </div>
  );
};
export default ServerMonitor;
